import { NodeClient } from '../../../clients/stratus/tntCommonResourceRegistry';
import { IAuthProviderService } from '../../../services/authProviderService';
import { TenantsDataRepository } from '../TenantDataRepository';
import { IEventService } from '../../../services/eventService';
import BaseTenantHandler from './BaseTenantHandler';
import * as T from './types';

/**
 * Abstract base class for Stratus-specific tenant handlers.
 * Extends BaseTenantHandler with Stratus-specific dependencies and clients.
 *
 * Use this class when implementing handlers that interact with Stratus APIs.
 */
export default abstract class StratusTenantHandler extends BaseTenantHandler {
  protected _nodeClient: NodeClient;
  protected _parentAuthProvider: IAuthProviderService;

  constructor({
    stack,
    authProvider,
    parentAuthProvider,
    tenantsDataRepository,
    eventService
  }: {
    stack: T.StackType;
    authProvider: IAuthProviderService;
    parentAuthProvider: IAuthProviderService;
    tenantsDataRepository?: TenantsDataRepository;
    eventService?: IEventService;
  }) {
    // Call parent constructor with common dependencies
    super({
      stack,
      authProvider,
      tenantsDataRepository,
      eventService
    });

    // Initialize Stratus-specific dependencies
    this._parentAuthProvider = parentAuthProvider;
    this._nodeClient = new NodeClient(
      NodeClient.getBaseUrl(this._stack),
      this._parentAuthProvider
    );
  }
}
